module.exports = __webpack_public_path__ + "img/logo.a15c8996.png";